import React, { useCallback, useMemo } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { setReviewToolImagesAutoRotation } from '@web-3d-tool/redux-logic/src/redux/feature/renderer/renderer.actions';
import { utils, logToTimberBI, biMethods } from '@web-3d-tool/shared-logic';
import styles from './imagePinButton.module.css';
import Button from '../Button';
const { useSelector, useDispatch } = require('react-redux');

const ImagePinButton = (props) => {
  const { sdk, isModelCompared } = props;
  const dispatch = useDispatch();
  const isAutoRotationEnabled = useSelector((state) => state.renderer.isReviewToolImagesAutoRotationEnabled);

  // memos
  const shouldShowPinButton = useMemo(
    () => utils.isAOHSEnv() && !(isModelCompared && sdk.pluginId.includes('_compare')),
    [isModelCompared, sdk.pluginId]
  );

  // callbacks
  const handleOnClick = useCallback(() => {
    dispatch(setReviewToolImagesAutoRotation({ isAutoRotationEnabled: !isAutoRotationEnabled }));

    logToTimberBI(
      biMethods.userActionBiLog({
        objectName: 'lock button - review tool',
        action: 'click',
        objectType: 'button',
        locationParentObject: utils.getLocationParentObject(sdk),
        selectedValue: isAutoRotationEnabled ? 'Active' : 'Inactive',
        automationId: '',
      })
    );
  }, [dispatch, isAutoRotationEnabled, sdk]);

  const className = classNames(styles.pinButton, {
    [styles.pinButtonImage]: isAutoRotationEnabled,
    [styles.pinButtonImageActive]: !isAutoRotationEnabled,
  });

  return (
    <>
      {shouldShowPinButton && (
        <Button
          onClick={() => handleOnClick()}
          className={className}
          data-test-id={'test-image-pin-button'}
          id={'image-pin-button'}
        ></Button>
      )}
    </>
  );
};

ImagePinButton.propTypes = {
  sourcesArr: PropTypes.array.isRequired,
};

export default ImagePinButton;
